/* eslint-disable extra-rules/no-commented-out-code */
import { SLASH_C_PATH, SLASH_C_ROUTE } from '../../../../../constants/plp.constants';
import { routerPush } from '../../../../../utils';
import { FACETS_FIELD_KEY } from '../../ProductListing/molecules/SortSelector/views/SortSelector.view';
import { CATEGORIES_TO_EXCLUDE } from './HorizontalCategory.constants';

export const getHlpCatgories = (currentCategory) => {
  const hlpCategories = [];
  if (!currentCategory) return hlpCategories;
  const { subCategories } = currentCategory;
  subCategories.forEach((category) => {
    // Remove the hardcoded SNJ category id and check with current plp implementation
    if (
      category.categoryContent &&
      category.categoryContent.displayToCustomer &&
      category.categoryContent.id !== '753001' &&
      !CATEGORIES_TO_EXCLUDE.includes(category.categoryContent.name)
    ) {
      const { hasL3, categoryContent, subCategories: sc } = category;
      hlpCategories.push({
        categoryInfo: { ...categoryContent },
        hasL3,
        subCatInfo: hasL3 > 0 ? sc?.categoryContent : {},
      });
    }
  });
  return hlpCategories;
};

const getFirstActiveSubCategory = (categories) => {
  return categories.find((category) => category?.categoryContent?.displayToCustomer === true);
};

const hasL3Categories = (category) =>
  category.hasL3 &&
  category.hasL3 > 0 &&
  category.subCategories &&
  category.subCategories.length > 0;

export const getFilteredHplpCategories = (categories) => {
  if (!categories || categories.length <= 0) return null;

  const filteredHplpCategories = [];
  categories.forEach((category) => {
    if (
      category.categoryContent &&
      category.categoryContent.displayToCustomer &&
      category.categoryContent.id !== '753001' &&
      !CATEGORIES_TO_EXCLUDE.includes(category.categoryContent.name) // Remove the hardcoded SNJ category id and check with current plp implementation
    ) {
      const hplpCategoryInfo = { categoryId: category.categoryContent.id };
      if (category?.categoryContent?.mainCategory?.espotPlp) {
        hplpCategoryInfo.espotData = category.categoryContent.mainCategory.espotPlp;
      }
      if (hasL3Categories(category)) {
        const firstActiveSubCategory = getFirstActiveSubCategory(category.subCategories);
        if (firstActiveSubCategory) {
          hplpCategoryInfo.hasL3 = true;
          hplpCategoryInfo.firstSubCategoryId = firstActiveSubCategory.categoryContent.id;
        }
      }
      filteredHplpCategories.push(hplpCategoryInfo);
    }
  });

  return filteredHplpCategories;
};

export const getAllHplpCategories = (category) => {
  const { subCategories } = category;

  if (!subCategories) return null;

  if (Array.isArray(subCategories)) {
    return getFilteredHplpCategories(subCategories);
  }

  const sortedSubCategoriesGroupNames = Object.keys(subCategories).sort((prevKey, currKey) => {
    return parseInt(subCategories[prevKey].order, 10) - parseInt(subCategories[currKey].order, 10);
  });

  if (!sortedSubCategoriesGroupNames || sortedSubCategoriesGroupNames.length <= 0) return null;

  const allHplpCategories = [];
  sortedSubCategoriesGroupNames.forEach((groupName) => {
    const categoryGroup = subCategories[groupName];
    if (!categoryGroup.hasSubCategory) return;
    const filteredHplpCategories = getFilteredHplpCategories(categoryGroup.items);
    if (filteredHplpCategories) {
      allHplpCategories.push(...filteredHplpCategories);
    }
  });

  return allHplpCategories;
};

export const isHplpCategory = (categoryId, hplpCategoriesIds) => {
  return (
    hplpCategoriesIds && hplpCategoriesIds.length > 0 && hplpCategoriesIds.includes(categoryId)
  );
};

export const doesListIncludes = (list, value) => {
  return value && list && list.length > 0 && list.includes(value.trim());
};

export const hasSubcategories = (category, categoryLevel) => {
  if (categoryLevel === 1) {
    return category.hasL2;
  }

  if (categoryLevel === 2) {
    return category.hasL3;
  }

  return false;
};

export const shouldRenderAsHplp = (category, categoryLevel, hplpCategoriesIds) => {
  return (
    isHplpCategory(category.categoryContent.id, hplpCategoriesIds) &&
    hasSubcategories(category, categoryLevel)
  );
};

export const some = () => null;

export const setUpdatedUrl = (pageType, cid, urlQueryValues) => {
  const routeUrl = urlQueryValues ? `/${pageType}/${cid}?${urlQueryValues}` : `/${pageType}/${cid}`;
  // Update the url in browser based on the filters applied
  routerPush(`${SLASH_C_PATH}cid=${cid}`, routeUrl, { shallow: true }, undefined, {
    scroll: false,
  });
  return routeUrl;
};

// const culteredFilter = (filters) => {
//   const updatedFilter = filters;
//   delete updatedFilter.action;
//   delete updatedFilter.min_offer_price;
//   return updatedFilter;
// };

// const evalAppliedFilters = (filtersAndSort) => {
//   const isPriceRemoveAction = filtersAndSort?.action ==='rm_price';
//     let appliedFiltersAndShorts = filtersAndSort;
//     if ( isPriceRemoveAction ) {
//       appliedFiltersAndShorts = culteredFilter(filtersAndSort);
//     }
//     return appliedFiltersAndShorts;
// };

export const getHplpUrlQueryValues = (filtersAndSort, pathName, isSortOrFilter) => {
  if (!isSortOrFilter) {
    return pathName.substr(pathName.indexOf(SLASH_C_ROUTE));
  }
  let urlQueryValues = '';
  if (filtersAndSort) {
    // const appliedFilters = evalAppliedFilters(filtersAndSort);
    Object.keys(filtersAndSort).forEach((key) => {
      if (filtersAndSort[key].length) {
        const filterParam =
          key === FACETS_FIELD_KEY.sort
            ? `${encodeURIComponent(key)}=${encodeURIComponent(filtersAndSort[key])}`
            : `${encodeURIComponent(key)}=${encodeURIComponent(filtersAndSort[key].join(','))}`;
        urlQueryValues = urlQueryValues ? `${urlQueryValues}&${filterParam}` : filterParam;
      }
    });
  }

  const [, , pageType, cid] = pathName.split('/');
  return setUpdatedUrl(pageType, cid, urlQueryValues);
};

export const getESpotHplpObject = (categoryInfo) => categoryInfo?.mainCategory?.espotPlp;

export const getHplpESpotCategoryID = (categoryInfo) => categoryInfo?.catgroupId;

export const getESpotHplp = (categoryInfo) => {
  const espotPlp = getESpotHplpObject(categoryInfo);
  return espotPlp
    ? {
        id: getHplpESpotCategoryID(categoryInfo),
        espotContentId: espotPlp[0].contentId,
        // eslint-disable-next-line no-underscore-dangle
        typeName: espotPlp[0].__typename,
      }
    : null;
};

export const findEspotHplpPromo = ({ categoryInfo }) => {
  if (!categoryInfo || categoryInfo?.length === 0) {
    return null;
  }
  return getESpotHplp(categoryInfo);
};
